import React, { useEffect, useRef, useState } from 'react';
import { Card, CardContent, Container, Grid, Table, TableHead, TableRow, TableCell, TableBody, Typography, TableContainer } from '@mui/material';

import DashboardCardStatus from '../../../components/card/dashboard-joblist/DashboardCardStatus'
import DashboardCardChart1 from '../../../components/card/dashboard-joblist/DashboardCardChart1'
import DashboardCardChart2 from '../../../components/card/dashboard-joblist/DashboardCardChart2'
import DashboardCardTable from '../../../components/card/dashboard-joblist/DashboardCardTable'

const DashboardJoblist: React.FC = () => {
    const tableRef = useRef<HTMLDivElement>(null);

    const [data, setData] = useState<any>([]);

    // Data dummy chart
    const datas = [
        { month: 'Jan', value: 20 },
        { month: 'Feb', value: 35 },
        { month: 'Mar', value: 40 },
        { month: 'Apr', value: 55 },
        { month: 'May', value: 30 },
    ];

    // Data dummy tabel
    const tableData = Array.from({ length: 30 }, (_, i) => ({
        no: i + 1,
        job: `Joblist ${i + 1}`,
        status: i % 2 === 0 ? 'Done' : 'Pending',
    }));

    // Auto scroll effect
    useEffect(() => {
        const el = tableRef.current;
        if (!el) return;

        let scrollDirection = 1;
        const interval = setInterval(() => {
            if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
                scrollDirection = -1; // scroll ke atas
            } else if (el.scrollTop <= 0) {
                scrollDirection = 1; // scroll ke bawah
            }
            el.scrollTop += scrollDirection * 1; // kecepatan scroll
        }, 30);

        return () => clearInterval(interval);
    }, []);

    return (
        <div
            style={{
                height: '100vh',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                padding: '16px',
                boxSizing: 'border-box'
            }}
        >
            {/* HEADER */}
            <Card
                sx={{
                    textAlign: 'center',
                    padding: 2,
                    marginBottom: 2,
                    flexShrink: 0,
                }}
            >
                <Typography variant="h5" fontWeight="bold" sx={{
                    color: '#212121'
                }}>
                    Dashboard Joblist
                </Typography>
            </Card>

            {/* CONTENT */}
            <Container maxWidth={false} sx={{ height: `calc(100vh - ${88 + 16}px)`, px: 3 }}>
                {/* Cards atas */}
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={4}>
                        <DashboardCardStatus />
                    </Grid>
                    <Grid item xs={4}>
                        <DashboardCardChart1 />
                    </Grid>
                    <Grid item xs={4}>
                        <DashboardCardChart2 />
                    </Grid>
                </Grid>

                <DashboardCardTable />
            </Container>
        </div>
    );
};

export default DashboardJoblist;
